import React, { useState } from 'react';
import './LoginHint.css';
import {useNavigate} from "react-router-dom"; // فایل استایل که در مرحله بعد ایجاد می‌کنیم

const LoginHint = () => {
    const navigate = useNavigate();
    // با استفاده از `useState` وضعیت نمایش یا عدم نمایش پیام را مدیریت می‌کنیم
    const [isVisible, setIsVisible] = useState(true);

    // تابعی برای بستن پیام
    const handleClose = () => {
        setIsVisible(false);
    };

    // اگر isVisible برابر با false باشد، کامپوننت چیزی را رندر نمی‌کند
    if (!isVisible) {
        return null;
    }

    return (
        <div className="login-hint-container "

        >
           <div className="row mx-0 px-0 ">
               <div className="col-1 pt-2">
                   <button onClick={handleClose} className="close-button">
                       &times;
                   </button>
               </div>
               <div className="col-8 pt-2">

                   <p className="hint-text text-small-2">برای استفاده از امکانات، وارد شوید</p>
               </div>
               <div className="col-3 px-0 pt-1"
                    onClick={() => {
                        navigate('/login')
                    }}
               >
                   <button className='btn bg-third-color w-100 text-small-2 text-white'>
                       ورود
                   </button>
               </div>
           </div>

        </div>
    );
};

export default LoginHint;
